import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Droplet, Thermometer, Home as HomeIcon, Bath, Wrench } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { services } from '../mockData';

const Services = () => {
  const getIcon = (iconName) => {
    const icons = {
      droplet: Droplet,
      thermometer: Thermometer,
      home: HomeIcon,
      bath: Bath,
      pipe: Wrench,
      utensils: Wrench
    };
    const IconComponent = icons[iconName] || Wrench;
    return <IconComponent className="w-10 h-10 text-yellow-500" />;
  };

  return (
    <div className="min-h-screen bg-black pt-24">
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-gradient-gold">Hizmetlerimiz</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              İzmir'de su kaçağı tespitinden tadilata kadar tüm tesisat hizmetleri
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {services.map((service) => (
              <Card key={service.id} className="bg-zinc-900 border-zinc-800 card-hover overflow-hidden">
                <div className="grid md:grid-cols-2 gap-0">
                  <div className="h-64 md:h-full overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6 flex flex-col justify-between">
                    <div>
                      <div className="mb-4">
                        {getIcon(service.icon)}
                      </div>
                      <h2 className="text-2xl font-bold text-white mb-3">{service.title}</h2>
                      <p className="text-gray-400 mb-4">{service.shortDesc}</p>
                      <ul className="space-y-2 mb-6">
                        {service.features.slice(0, 3).map((feature, index) => (
                          <li key={index} className="text-sm text-gray-300 flex items-start">
                            <span className="text-yellow-500 mr-2">•</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <Link to={`/hizmet/${service.id}`}>
                      <Button className="w-full bg-yellow-500 text-black hover:bg-yellow-600">
                        Detaylı Bilgi
                        <ArrowRight className="w-4 h-4 ml-2" />
                      </Button>
                    </Link>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
